<div class="container-fluid attendance-fixed-viewport">
  <!-- Main Card Container -->
  <div class="card attendance-dashboard-card">
    <!-- Card Header with Title and Filters -->
    <div class="card-header">
      <div class="d-flex align-items-start justify-content-between gap-3">

        <!-- Left: Title -->
        <div class="header-title" style="min-width: 200px;">
          <h2 class="mb-0">Employee Attendance</h2>
          <p class="subtitle mb-0">Track and manage employee attendance records</p>
        </div>

        <!-- Right: All controls -->
        <div class="d-flex flex-column gap-2 flex-grow-1 align-items-end">

          <!-- Row 1: Shift Assignment + Date Range + Department + Employee -->
          <div class="d-flex align-items-end gap-2" [formGroup]="filterForm">

            <div style="padding-bottom: 0.01px;">
              <button type="button" class="btn btn-primary shift-assignment-btn" style="white-space: nowrap;"
                (click)="goToShiftAssignment()">
                <i class="fas fa-user-clock me-1"></i> Shift Assignment
              </button>
            </div>

            <div>
              <label class="form-label mb-1">Date</label>
              <input type="date" class="form-control" [value]="formattedDate" (change)="onDateChange($event)"
                style="width: 160px;" [max]="maxDate" />
            </div>

            <div *ngIf="!isFactoryManager && !isSupervisor" style="width: 160px;">
              <label class="form-label mb-1">Department</label>
              <ng-select [items]="departmentDropdown" bindLabel="department_name" placeholder="Select"
                formControlName="selectedDepartment" (change)="onDepartmentChange($event)">
              </ng-select>
            </div>

            <div *ngIf="!isSupervisor" style="width: 160px;">
              <label class="form-label mb-1">Employee</label>
              <ng-select [items]="employeeDropdown" bindLabel="employee_name" placeholder="Select"
                formControlName="selectedEmployee" (change)="onEmployeeChange($event)" bindValue="employee_id">
              </ng-select>
            </div>

          </div>

          <!-- Row 2: Apply + Export aligned under Department + Employee -->
          <div class="d-flex align-items-center gap-2">
            <!-- <button class="btn btn-primary" style="width: 160px;" (click)="onDateRangeApply()">Apply</button> -->
            <button class="filterApply" style="width: 160px; margin-top: 0;" (click)="openExportModal()"
              [disabled]="isModalOpen">
              <i class="fas fa-download me-1"></i>
              {{ isModalOpen ? 'Opening...' : 'Export' }}
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- Loading State with Custom Logo Animation -->
    <div *ngIf="isLoading" class="attendance-loading-container">
      <div class="attendance-custom-loader">
        <div class="attendance-loader-emblem-container">
          <img src="assets/img/logo.png" alt="Company Logo" class="attendance-loader-emblem" />
          <div class="attendance-loading-circle"></div>
        </div>
        <p class="attendance-loading-text">Loading dashboard data...</p>
      </div>
    </div>

    <!-- Card Body with Attendance Data - SCROLLABLE SECTION -->
    <div class="card-body attendance-scrollable-content" *ngIf="!isLoading">
      <!-- Summary Stats -->
      <div class="summary-stats mb-4">
        <div class="row">
          <!-- Card 1: Overall Attendance - Changed from col-md-3 to col-md-2 -->
          <div class="col-md-3">
            <div class="stat-card">
              <div class="stat-value">{{ attendancePercentage }}%</div>
              <div class="stat-label">Overall Attendance</div>
              <div class="stat-progress">
                <div class="progress-bar bg-success" [style.width.%]="attendancePercentage"></div>
              </div>
            </div>
          </div>

          <!-- ✅ Card 2: FILTERABLE STAT with Dropdown AS LABEL - Changed from col-md-3 to col-md-2 -->
          <!-- <div class="col-md-3">
            <div class="stat-card clickable-stat" (click)="filterEmployeesByStatus(selectedFilter)">
              <div class="stat-value">{{ filteredPercentage }}%</div>
              <div class="stat-label-dropdown">
                <select class="stat-label-select" [(ngModel)]="selectedFilter" (change)="onFilterChange(selectedFilter)"
                  (click)="$event.stopPropagation()">
                  <option *ngFor="let option of attendanceFilterOptions" [value]="option.value">
                    {{ option.label }} Rate
                  </option>
                </select>
              </div>
              <div class="stat-progress">
                <div class="progress-bar" [ngClass]="getFilterColorClass()" [style.width.%]="filteredPercentage"></div>
              </div>
            </div>
          </div> -->

          <div class="col-md-3">
            <div class="stat-card clickable-stat" (click)="filterEmployeesByStatus(selectedFilter)">
              <div class="stat-value">{{ filteredPercentage }}%</div>
              <div class="stat-label-dropdown">
                <select class="stat-label-select" [(ngModel)]="selectedFilter" (change)="onFilterChange(selectedFilter)"
                  (click)="$event.stopPropagation()"
                  style="appearance: none; -webkit-appearance: none; -moz-appearance: none; background-image: none; padding-right: 8px;">
                  <option *ngFor="let option of attendanceFilterOptions" [value]="option.value">
                    {{ option.label }} Rate
                  </option>
                </select>
              </div>
              <div class="stat-progress">
                <div class="progress-bar" [ngClass]="getFilterColorClass()" [style.width.%]="filteredPercentage"></div>
              </div>
            </div>
          </div>

          <!-- Card 3: Present Employees - Changed from col-md-3 to col-md-2 -->
          <div class="col-md-3">
            <div class="stat-card">
              <div class="stat-value">{{ fullDayCount }}</div>
              <div class="stat-label">Present Employees</div>
              <div class="stat-progress">
                <div class="progress-bar bg-secondary"
                  [style.width.%]="(fullDayCount / (fullDayCount + absentCount)) * 100"></div>
              </div>
            </div>
          </div>

          <!-- ✅ Card 4: FILTERABLE COUNT with Dropdown AS LABEL - Changed from col-md-3 to col-md-2 -->
          <!-- <div class="col-md-2">
            <div class="stat-card clickable-stat" (click)="filterEmployeesByStatus(selectedFilter)">
              <div class="stat-value">{{ filteredCount }}</div>
              <div class="stat-label-dropdown">
                <select class="stat-label-select" [(ngModel)]="selectedFilter" (change)="onFilterChange(selectedFilter)"
                  (click)="$event.stopPropagation()">
                  <option *ngFor="let option of attendanceFilterOptions" [value]="option.value">
                    {{ option.label }} Employees
                  </option>
                </select>
              </div>
              <div class="stat-progress">
                <div class="progress-bar" [ngClass]="getFilterColorClass()"
                  [style.width.%]="(filteredCount / (fullDayCount + absentCount)) * 100"></div>
              </div>
            </div>
          </div> -->

          <!-- ✅ NEW: Card 5: Half Days Card with Dropdown -->
          <!-- <div class="col-md-2">
            <div class="stat-card clickable-stat" (click)="filterEmployeesByHalfDayType(selectedHalfDayType)">
              <div class="stat-value">{{ getHalfDayCountForType(selectedHalfDayType) }}</div>
              <div class="stat-label-dropdown">
                <select class="stat-label-select" [(ngModel)]="selectedHalfDayType"
                  (change)="onHalfDayTypeChange(selectedHalfDayType)" (click)="$event.stopPropagation()">
                  <option *ngFor="let option of halfDayTypeOptions" [value]="option.value">
                    {{ option.label }}
                  </option>
                </select>
              </div>
              <div class="stat-progress">
                <div class="progress-bar bg-warning" [style.width.%]="halfDayPercentage"></div>
              </div>
            </div>
          </div> -->

          <!-- Card 6: Absent Employees (if you want to keep it separate) -->
          <div class="col-md-3">
            <div class="stat-card">
              <div class="stat-value">{{ absentCount }}</div>
              <div class="stat-label">Absent Employees</div>
              <div class="stat-progress">
                <div class="progress-bar bg-danger" [style.width.%]="absentPercentage"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Filter Status -->
      <div *ngIf="showOnlyAbsent" class="alert alert-info d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-info-circle me-2"></i>
          Showing only <strong>{{ getFilterLabel() }}</strong> employees.
          <button class="btn btn-sm btn-outline-primary ms-2" (click)="clearFilter()">
            Show All Employees
          </button>
        </div>
        <span class="badge" [ngClass]="getFilterColorClass()">
          Filtered: {{ displayGroupedEmployee?.length }} employees
        </span>
      </div>

      <!-- Attendance Table with Frozen Header -->
      <div class="table-wrapper-frozen">
        <table class="table attendance-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Employee Name</th>
              <th>Department</th>
              <th>Attendance Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let employee of displayGroupedEmployee; index as i">
              <td routerLink="/admin/employee-attendance-beta-details"
                [queryParams]="{ id: employee.employee_id, month: getMonthFromDate(formattedDate) }"
                class="clickable-cell">
                {{ i + 1 }}
              </td>
              <td routerLink="/admin/employee-attendance-beta-details"
                [queryParams]="{ id: employee.employee_id, month: getMonthFromDate(formattedDate) }"
                class="clickable-cell">
                {{ employee.employee_name }}
              </td>
              <td routerLink="/admin/employee-attendance-beta-details"
                [queryParams]="{ id: employee.employee_id, month: getMonthFromDate(formattedDate) }"
                class="clickable-cell">
                {{ employee.department }}
              </td>
              <td routerLink="/admin/employee-attendance-beta-details"
                [queryParams]="{ id: employee.employee_id, month: getMonthFromDate(formattedDate) }"
                class="clickable-cell">
                <span [ngClass]="getAttendanceStatusClass(employee)">
                  {{ getDisplayAttendanceStatus(employee) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- No Data Message for Filter -->
      <div *ngIf="showOnlyAbsent && displayGroupedEmployee.length === 0" class="alert alert-warning text-center">
        No absent employees found for the selected date.
      </div>
    </div>
  </div>
</div>

<!-- Export Modal -->
<div class="modal fade" id="exportModal" tabindex="-1" aria-hidden="true" #exportModal
  (hidden.bs.modal)="onModalHidden()">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-download me-2"></i>
          Export Attendance Data
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeExportModal()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="exportForm">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">From Date</label>
              <input type="date" class="form-control" formControlName="fromDate"
                [max]="exportForm.get('toDate')?.value || maxDate" />
              <div *ngIf="exportForm.get('fromDate')?.invalid && exportForm.get('fromDate')?.touched"
                class="text-danger small">
                From Date is required
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label">To Date</label>
              <input type="date" class="form-control" formControlName="toDate" [min]="exportForm.get('fromDate')?.value"
                [max]="maxDate" />
              <div *ngIf="exportForm.get('toDate')?.invalid && exportForm.get('toDate')?.touched"
                class="text-danger small">
                To Date is required
              </div>
            </div>



            <div class="col-12" *ngIf="exportForm.get('fromDate')?.value && exportForm.get('toDate')?.value">
              <div class="alert alert-info">
                <small>
                  <i class="fas fa-info-circle me-1"></i>
                  Exporting data from <strong>{{ exportForm.get('fromDate')?.value | date }}</strong>
                  to <strong>{{ exportForm.get('toDate')?.value | date }}</strong>
                </small>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" (click)="closeExportModal()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="downloadExport()"
          [disabled]="exportForm.invalid || isExporting">
          <span *ngIf="isExporting" class="spinner-border spinner-border-sm me-2"></span>
          {{ isExporting ? 'Exporting...' : 'Download' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Edit Attendance Modal -->
<div class="modal fade" id="editAttendanceModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-calendar-check me-2"></i>
          Edit Attendance Record
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Date</label>
              <input type="date" class="form-control" value="2025-06-02" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Employee</label>
              <input type="text" class="form-control" value="Ali Mohammed" readonly />
            </div>
            <div class="col-md-3">
              <label class="form-label">Work In</label>
              <input type="time" class="form-control" value="08:10" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Break Out</label>
              <input type="time" class="form-control" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Break In</label>
              <input type="time" class="form-control" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Work Out</label>
              <input type="time" class="form-control" value="19:10" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Status</label>
              <select class="form-select">
                <option>Full Day</option>
                <option>Half Day</option>
                <option selected>Absent</option>
                <option>Leave</option>
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label">Leave Type</label>
              <select class="form-select">
                <option selected>None</option>
                <option>Annual Leave (AL)</option>
                <option>Casual Leave (CL)</option>
                <option>Sick Leave (SL)</option>
              </select>
            </div>
            <div class="col-12">
              <label class="form-label">Remarks</label>
              <textarea class="form-control" rows="3"></textarea>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
          Cancel
        </button>
        <button type="button" class="btn btn-primary">Save Changes</button>
      </div>
    </div>
  </div>
</div>